(function () {
  'use strict';

  var TABLET_MIN = 750;
  var TABLET_MAX = 1366;
  var TABLET_MIN_HEIGHT = 600;
  var resizeTimer = null;

  function isIpadLike() {
    return /iPad/.test(navigator.userAgent || '') ||
      (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
  }

  function isCoarseTouchOnly() {
    return window.matchMedia('(hover: none) and (pointer: coarse)').matches;
  }

  function isTablet() {
    var width = window.innerWidth;
    var height = window.innerHeight;
    if (width < TABLET_MIN || width > TABLET_MAX || height < TABLET_MIN_HEIGHT) return false;
    if (isIpadLike()) return true;

    var fineDesktopPointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    return isCoarseTouchOnly() && !fineDesktopPointer;
  }

  function syncRootClasses() {
    var tablet = isTablet();
    var mobile = window.innerWidth < TABLET_MIN;
    var root = document.documentElement;

    root.classList.toggle('kfa-mobile', mobile);
    root.classList.toggle('kfa-tablet', tablet);
    root.classList.toggle('kfa-desktop', !mobile && !tablet);
  }

  function syncHeaderMenuStyle() {
    var headerComponent = document.querySelector('#header-component');
    if (!headerComponent) return;

    var overflowList = headerComponent.querySelector('overflow-list');
    var hasReachedMinimum = !!(overflowList && overflowList.hasAttribute('minimum-reached'));
    var root = document.documentElement;
    var useDrawer = root.classList.contains('kfa-mobile') ||
      root.classList.contains('kfa-tablet') ||
      hasReachedMinimum;

    headerComponent.dataset.menuStyle = useDrawer ? 'drawer' : 'menu';
  }

  function removeMixedInteractionState() {
    if (!document.documentElement.classList.contains('kfa-tablet')) return;

    document.querySelectorAll('.kfa-desktop-reveal').forEach(function (node) {
      node.classList.remove('kfa-desktop-reveal');
    });

    document.querySelectorAll('section.okd-world').forEach(function (world) {
      world.classList.remove(
        'kfa-atelir-intro-enabled',
        'kfa-atelir-question-visible',
        'kfa-atelir-answer-visible',
        'kfa-atelir-first-leaving',
        'kfa-atelir-journey-visible',
        'kfa-atelir-further-visible',
        'kfa-atelir-second-leaving'
      );
      world.classList.add('kfa-atelir-nav-ready', 'kfa-atelir-intro-ended');
    });
  }

  function syncAll() {
    syncRootClasses();
    syncHeaderMenuStyle();
    removeMixedInteractionState();
  }

  function scheduleSync() {
    window.clearTimeout(resizeTimer);
    resizeTimer = window.setTimeout(syncAll, 50);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncAll, { once: true });
  } else {
    syncAll();
  }

  window.addEventListener('resize', scheduleSync, { passive: true });
  window.addEventListener('orientationchange', function () {
    window.setTimeout(syncAll, 90);
  }, { passive: true });
  window.addEventListener('pageshow', syncAll, { passive: true });
  document.addEventListener('shopify:section:load', syncAll);

  var headerObserver = new MutationObserver(function () {
    syncHeaderMenuStyle();
  });

  var interactionObserver = new MutationObserver(function () {
    removeMixedInteractionState();
  });

  function observeDynamicState() {
    var headerComponent = document.querySelector('#header-component');
    if (headerComponent) {
      headerObserver.disconnect();
      headerObserver.observe(headerComponent, {
        subtree: true,
        attributes: true,
        attributeFilter: ['minimum-reached']
      });
    }

    interactionObserver.disconnect();
    interactionObserver.observe(document.documentElement, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ['class']
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeDynamicState, { once: true });
  } else {
    observeDynamicState();
  }
})();
